export default "//cloud.imgsmail.ru/cloud.mail.ru/123509/img/build/facebook-popup/success-phone.png";